import { useState, useEffect } from "react";
import oneRoomNoticeImage from '../../assets/images/pho_oneroom_NG.png'
import { HintPopup } from './common/HintPopup';

interface OneRoomNoticePopupProps {
  isOpen: boolean;
  onClose: () => void;
  ignoreFlag?: boolean; // フラグを無視して表示する場合はtrue
}

const OneRoomNoticePopup = ({ isOpen, onClose, ignoreFlag = false }: OneRoomNoticePopupProps) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleClose = () => {
    if (dontShowAgain) {
      // LocalStorageに「次回から表示しない」設定を保存
      localStorage.setItem('oneRoomNoticeHidden', 'true');
    }
    onClose();
  };

  // 初回表示時に「次回から表示しない」設定を確認（ignoreFlagがfalseの場合のみ）
  useEffect(() => {
    if (!ignoreFlag) {
      const hidden = localStorage.getItem('oneRoomNoticeHidden');
      if (hidden === 'true' && isOpen) {
        onClose();
      }
    }
  }, [isOpen, onClose, ignoreFlag]);

  return (
    <HintPopup
      show={isOpen}
      image={oneRoomNoticeImage}
      imageAlt="ワンルームにおける入力画像の注意点"
      onClose={handleClose}
      showCheckbox={true}
      checkboxValue={dontShowAgain}
      onCheckboxChange={setDontShowAgain}
      maxWidth="1000px"
    />
  );
};

export default OneRoomNoticePopup;
